import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
// import Message from "../../Message";
import { Row, Col, Card, Button, FormControl } from 'react-bootstrap';
import PageHeader from '../../../Layouts/PageHeader/PageHeader';
import MessageLogsService from '../../../services/MessageLogsService';
import usePermissions from '../../../hooks/usePermissions';
import DataTable from 'react-data-table-component';
import dayjs from 'dayjs';


const MessageLogsList = () => {
  const location = useLocation();
  const [balances, setBalances] = useState([]);
    const { hasPermission } = usePermissions();
  const [userPermissions, setUserPermissions] = useState([]);
  const [filterText, setFilterText] = useState('');

 

  useEffect(() => {
    const fetchData = async () => {
      const data = await MessageLogsService.getAll();

      setBalances(data.message_responses);
    };
    fetchData();
  }, []);

  // const handleDelete = (uuid) => {
  //   setSelectedWeek(uuid);
  //   setVisible(true);
  // };

  // const confirmDelete = async () => {
  //   const data = await WeekService.deleteWeek(selectedWeek);
  //   setWeeks(balances.filter(row => row.uuid !== selectedWeek));
  //   setMessage(data);
  //   setVisible(false);
  // };

  // Filtered data
  const filteredAccounts = balances.filter(
    rowFilter => rowFilter.message_body && rowFilter.message_body.toLowerCase().includes(filterText.toLowerCase()) ||
      (rowFilter.created_at && rowFilter.created_at.toLowerCase().includes(filterText.toLowerCase())) ||
      (rowFilter.sender_name && rowFilter.sender_name.toLowerCase().includes(filterText.toLowerCase())) ||
      (rowFilter.message_error && rowFilter.message_error.toLowerCase().includes(filterText.toLowerCase()))


  );

  // Define columns for the data table
  const columns = [
    {
      name: 'created_at',
      selector: row => dayjs(row.created_at).format('YYYY-MM-DD'),
      sortable: true,
      wrap: true,
    },
     


    {
      name: 'phone',
      selector: row => `${row.sender_name} - ${row.phone_number}`,
      sortable: true,
      // wrap: true,
    },
    {
      name: 'message_body',
      selector: row => row.message_body,
      sortable: true,
      wrap: true,
    },
    {
      name: 'message_error',
      selector: row => row.message_error,
      sortable: true,
      wrap: true,
    },



  ];

  return (
    <div>
      <PageHeader titles="Message Logs" active="List" items={['sms Logs']} />
       

      <Row>
        <Col xl={12}>
          <Card>
            <Card.Header>
              <Card.Title as='h3'>

              </Card.Title>
              <FormControl
                type="text"
                placeholder="Search ..."
                className="mt-2"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </Card.Header>
            <Card.Body>
              <div style={{ overflowX: 'auto' }}>
                <DataTable
                  columns={columns}
                  data={filteredAccounts}
                  pagination
                  highlightOnHover
                  striped
                />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>


    </div>
  );
};

export default MessageLogsList;
